import {createFileRoute, redirect} from "@tanstack/react-router";
import {isAuthenticated} from "../../utils/auth.ts";

export const Route = createFileRoute('/settings/')({
  beforeLoad: async () => {
    if (!isAuthenticated()) {
      throw redirect({to: '/', replace: true});
    }
    // Redirect to /settings/general by default
    throw redirect({to: '/settings/general', replace: true});
  },
  component: () => null,
});